// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"92a6238f0d286b1c7717","655":"1c89906e340ab4709da8"}[chunkId] + ".js";
};